(() => {
  if (window.lumosSharedCartDrawer) return;

  const observers = new Map();
  const syncProgress = (drawer) => {
    const state = drawer.querySelector('form.Cart template[data-lumos-cart-progress]');
    const text = drawer.querySelector('#progressbar .progressbar-text');
    const bar = drawer.querySelector('#progressbar .progress-done');
    if (!state || !text || !bar) return;
    if (text.innerHTML !== state.innerHTML) text.innerHTML = state.innerHTML;
    const percent = Number(state.dataset.percent);
    bar.style.width = `${Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 0}%`;
    bar.style.opacity = '1';
  };

  const mount = () => {
    for (const [drawer, observer] of observers) {
      if (!drawer.isConnected) {
        observer.disconnect();
        observers.delete(drawer);
      }
    }
    document.querySelectorAll('[data-lumos-cart-drawer]').forEach((drawer) => {
      syncProgress(drawer);
      if (observers.has(drawer)) return;
      const observer = new MutationObserver(() => syncProgress(drawer));
      observer.observe(drawer, { childList: true, subtree: true });
      observers.set(drawer, observer);
    });
  };

  const resetCheckout = () => {
    document.querySelectorAll('#sidebar-cart[data-lumos-cart-drawer] form.Cart').forEach((form) => {
      const button = form.querySelector('button[name="checkout"]');
      delete form.dataset.checkoutSubmitPending;
      delete form.dataset.checkoutSubmitting;
      if (button) {
        delete button.dataset.checkoutSubmitting;
        button.removeAttribute('aria-busy');
      }
    });
    mount();
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('#sidebar-cart[data-lumos-cart-drawer] form.Cart');
    const button = event.submitter;
    if (!form || !button || button.name !== 'checkout' || button.form !== form) return;
    if (form.dataset.checkoutSubmitPending === 'true' || form.dataset.checkoutSubmitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.checkoutSubmitPending = 'true';
    Promise.resolve().then(() => {
      delete form.dataset.checkoutSubmitPending;
      if (event.defaultPrevented || !form.isConnected || !button.isConnected) return;
      form.dataset.checkoutSubmitting = 'true';
      button.dataset.checkoutSubmitting = 'true';
      button.setAttribute('aria-busy', 'true');
    });
  }, true);

  window.lumosSharedCartDrawer = { mount };
  window.addEventListener('pageshow', resetCheckout);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [drawer, observer] of observers) {
      if (event.target.contains(drawer)) {
        observer.disconnect();
        observers.delete(drawer);
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
